import { useState, type FormEvent } from 'react';
import { primaryButtonClass } from '@/shared/ui/formClasses';
import { resetPasswordErrors, type ResetPasswordErrors } from '../model/passwords';
import PasswordField from './PasswordField';

type ResetPasswordFormProps = {
  submitting: boolean;
  onSubmit: (password: string) => void;
};

/** `onSubmit(password)` con una password già valida; un solo pulsante mostra e nasconde entrambe. */
export default function ResetPasswordForm({ submitting, onSubmit }: ResetPasswordFormProps) {
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState<ResetPasswordErrors>({});

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    const found = resetPasswordErrors(password, confirmation);
    setErrors(found);
    if (Object.keys(found).length === 0) onSubmit(password);
  };

  return (
    <form noValidate onSubmit={handleSubmit} className="mt-8 space-y-5">
      <PasswordField
        id="new-password"
        label="Nuova password"
        required
        autoComplete="new-password"
        value={password}
        onChange={setPassword}
        error={errors.password}
        hint="Almeno 8 caratteri."
        visible={showPassword}
        onToggleVisible={() => setShowPassword((visible) => !visible)}
      />
      <PasswordField
        id="confirm-password"
        label="Conferma password"
        required
        autoComplete="new-password"
        value={confirmation}
        onChange={setConfirmation}
        error={errors.confirmation}
        visible={showPassword}
      />
      <button type="submit" disabled={submitting} className={`${primaryButtonClass} w-full`}>
        {submitting ? 'Salvataggio…' : 'Imposta password'}
      </button>
    </form>
  );
}
